// extracted by mini-css-extract-plugin
export default {"hideTooltip":"I9-z","fadeIn":"J9-z","delay":"K9-z","recommendedSizeTooltip":"L9-z"};